import Underlining from "../../../../src/styles/underlining";
import * as React from 'react';
export default {
  Underlining,
  React
};